// extracted by mini-css-extract-plugin
export default {"advertDetailContacts":"c-l_gG","advertDetailContacts__header":"c-l_gH"};